
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import {  TResponseWithQData } from "../../../types/common";
import { DashboardStatsResponse } from '../../../types/api/dashboard';



export async function dashboardDetails(): Promise<AxiosResponse<TResponseWithQData<DashboardStatsResponse>>> {
    return axios.get(API_ENDPOINTS.DASHBOARD_STATS)
}


